import {injectable} from '@123/druid/dist/Framework/Decorators/Inject';
import Assert from '@123/druid/dist/Utility/Assert';
import type {ConfigType} from '@Service/Config/Types/ConfigType';

@injectable()
export default class Config {
    private readonly configStore: Map<ConfigType, string> = new Map();

    public getConfig(key: ConfigType): string {
        const storedConfig = this.configStore.get(key);
        if (storedConfig) {
            return storedConfig;
        }

        const value = this.getConfigFromMeta(key);
        this.configStore.set(key, value);
        return value;
    }

    private getConfigFromMeta(key: ConfigType): string {
        const meta: HTMLMetaElement = Assert.notNull(document.querySelector(`meta[name="${key}"]`));

        return Assert.notNull(meta.getAttribute('content'));
    }
}
